function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame 72"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.538 2.76953C6.18854 2.76953 1.8457 7.11237 1.8457 12.4618C1.8457 17.8113 6.18854 22.1541 11.538 22.1541C16.8875 22.1541 21.2303 17.8113 21.2303 12.4618C21.2303 7.11237 16.8875 2.76953 11.538 2.76953ZM12.4152 17.4662C12.2858 17.6675 12.1563 17.9407 11.8688 17.9407C11.6243 17.9407 11.423 17.6962 11.3079 17.495L8.8417 13.0083L6.37549 8.52164C6.24607 8.27718 6.13103 8.00396 6.10226 7.74511C6.05912 7.28494 6.38987 6.99734 6.77814 6.99734C7.8998 6.99734 9.23716 6.98295 10.3732 6.99734C10.8334 7.01171 11.1641 7.19866 11.3942 7.67321C11.9119 8.73735 12.0989 9.51388 12.7747 10.4773C12.8035 10.5205 12.8322 10.5636 12.861 10.5924C13.6519 11.4408 15.5214 12.0016 16.9737 9.48512L12.4152 17.4662Z",
    fill: "white",
    style: {
      mixBlendMode: "difference"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVToken);
export default __webpack_public_path__ + "static/media/vToken.cad1e8c69ec123e221fe6ba5e8ca6540.svg";
export { ForwardRef as ReactComponent };